import toast from "react-hot-toast";
import useApi from "../useApi";
import { StartTimerRequest, TimerResponse } from "./index.type";

const useStartTimerAutomatic = ({
  patientId,
  clinicId,
}: {
  patientId: string;
  clinicId: string;
}) => {
  const url = `/rtm/timer/start?associatedClinicianId=${clinicId}&patientId=${patientId}`;
  const method = "POST";
  const { loading: StartTimerLoading, makeApiCall } = useApi({ url, method });

  const StartTimer = async (formData: StartTimerRequest) => {
    const { response, error } = await makeApiCall<
      StartTimerRequest,
      TimerResponse
    >(formData);

    if (response?.status === "success") {
      return response;
    }

    if (response?.status === "fail") {
      toast.error(response.msg || "Failed to start timer. Please try again.");
      return response;
    }
  };

  return {
    StartTimerLoading,
    StartTimer,
  };
};

export default useStartTimerAutomatic;
